import { render, staticRenderFns } from "./BannerHome.page.vue?vue&type=template&id=1a747fb9&"
import script from "./BannerHome.page.vue?vue&type=script&lang=js&"
export * from "./BannerHome.page.vue?vue&type=script&lang=js&"
import style0 from "./BannerHome.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports